import { render, staticRenderFns } from "./reservation.vue?vue&type=template&id=00fdd755&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=ts"
export * from "./reservation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fdd755",
  null
  
)

export default component.exports